(function () {
  if (window.__pcColorInit) return;
  window.__pcColorInit = true;

  var cache = {};
  var SW = 'a[href*="/products/"], [data-handle], [data-product-handle], [data-product-url], [data-url], [data-href]';

  var st = document.createElement('style');
  st.textContent = '.pc-hide{display:none!important}';
  document.head.appendChild(st);

  function handleOf(el) {
    var v = el.getAttribute('href') || el.getAttribute('data-product-url') || el.getAttribute('data-url') || el.getAttribute('data-href') || '';
    var m = v.match(/\/products\/([^\/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    return el.getAttribute('data-handle') || el.getAttribute('data-product-handle') || '';
  }

  function ownHandle(card) {
    var a = card.querySelector('a.product-image');
    return a ? handleOf(a) : '';
  }

  function colorEl(card, create) {
    var t = card.querySelector('.pc-text');
    if (!t) return null;
    var c = t.querySelector('.pc-color');
    if (!c && create) {
      c = document.createElement('div');
      c.className = 'pc-color';
      t.insertBefore(c, t.firstChild);
    }
    return c;
  }

  function setColor(card, text) {
    var ce = colorEl(card, !!text);
    if (!ce) return;
    ce.textContent = text || '';
    ce.style.display = text ? '' : 'none';
  }

  function getColor(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=pccolor', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        t = (t || '').trim();
        if (t.length > 60 || /<[a-z!]/i.test(t)) t = '';
        cache[handle] = t;
        return t;
      })
      .catch(function () { return ''; });
  }

  function prepare(card) {
    if (card.dataset.pcOrig !== undefined) return;
    var c = colorEl(card);
    card.dataset.pcOrig = c ? c.textContent.trim() : '';
    card.dataset.pcOwn = ownHandle(card);
  }

  function hideDup(card) {
    var info = card.querySelector('.product__information');
    var want = (card.dataset.pcOrig || '').trim().toLowerCase();
    if (!info || !want) return;
    var all = info.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length) continue;
      if (el.classList.contains('pc-hide')) continue;
      if (el.closest('.pc-text, .product__price, .product__tag, a, button, label, [role="button"], svg')) continue;
      if (el.textContent.trim().toLowerCase() === want) el.classList.add('pc-hide');
    }
  }

  function processAll() {
    try {
      var cards = document.querySelectorAll('.product-item');
      for (var i = 0; i < cards.length; i++) {
        prepare(cards[i]);
        hideDup(cards[i]);
      }
    } catch (e) {}
  }

  function swatchOf(card, t) {
    var info = card.querySelector('.product__information');
    if (!info || !info.contains(t)) return null;
    if (t.closest('.pc-text, .product__price, .product__tag')) return null;
    var sw = t.closest(SW);
    return sw && info.contains(sw) ? sw : null;
  }

  function onEnter(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.product-item');
      if (!card) return;
      var sw = swatchOf(card, t);
      if (!sw) return;
      var h = handleOf(sw);
      if (!h) return;
      prepare(card);
      var tok = String(Date.now()) + Math.random();
      card.__pcTok = tok;
      if (h === card.dataset.pcOwn) {
        setColor(card, card.dataset.pcOrig);
        return;
      }
      getColor(h).then(function (txt) {
        if (card.__pcTok === tok && txt) setColor(card, txt);
      });
    } catch (err) {}
  }

  function onLeave(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest('.product-item');
      if (!card || card.dataset.pcOrig === undefined) return;
      var sw = swatchOf(card, t);
      if (!sw) return;
      var rel = e.relatedTarget;
      if (rel && rel.closest) {
        var rs = rel.closest(SW);
        if (rs && card.contains(rs) && !rs.closest('.pc-text, .product__price, .product__tag')) return;
      }
      card.__pcTok = 'left';
      setTimeout(function () {
        var cur = ownHandle(card);
        if (!cur || cur === card.dataset.pcOwn) {
          setColor(card, card.dataset.pcOrig);
        } else {
          getColor(cur).then(function (x) { if (x) setColor(card, x); });
        }
      }, 200);
    } catch (err) {}
  }

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('click', onEnter);
  document.addEventListener('mouseout', onLeave);

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(processAll, 250);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  schedule();
})();
